<template>

    <div class="switch">
        <label>
            <input type="checkbox"
                   v-bind:checked="typeSol"
                   v-bind:disabled="switchDisable"
                   v-on:change="$emit('change', $event.target.checked)"
            >
            <span class="lever"></span>
        </label>
    </div>

</template>

<script>
    export default {
        name: "switcher",
        props: {
            typeSol:Boolean,
            switchDisable:Boolean
        },
        model: {
            prop: 'checked',
            event: 'change'
        },
        data() {
            return {
                // switchValue:this.typeSol,
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>